import React, { useEffect } from 'react';
import { Box, Button, Checkbox, FormControlLabel, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { StickyNote2 } from '@mui/icons-material';
import { useState } from 'react';
import InputField from '../../components/formElements/InputField';
import { showSuccessSnackbar } from '../../components/snackBar/snakbar';
import { useSelector } from 'react-redux';
import { handleFreeze } from '../../utils/common';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { useCreatePaymentSettingsMutation, useGetPaymentSettingsQuery } from '../../redux/apis/paymentSettings.api';
import { Modal } from '../../components/modals/Modal';
// import EmailSettings from "./EmailSettings";
import CloseIcon from '@mui/icons-material/Close';
import { EmailSettings } from '../../features/Email';

const initialState = {
  enable_itemwiseentry: 0,
  enable_creditperiod: 0,
  enable_creditlimit: 0,
  enable_autopayreminder: 0,
  enable_autoreminderdays: 0,
};
const PaymentSettings = ({ emailExpand, title, height, parent }) => {
  const [bool, setBool] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [data, setdata] = useState({
    ...initialState,
    enable_autoreminderdays: 0,
    errorStatus: {
      enable_autoreminderdays: false,
    },
    errorFields: {
      enable_autoreminderdays: '',
    },
  });

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [
    createPaymentSettings,
    { isLoading: isCreatingPSettings, isError: isCreatePSettingsError, isSuccess: isCreatePSettingsSuccess, error: createPSettingsError },
  ] = useCreatePaymentSettingsMutation();
  const saveChanges = async () => {
    try {
      if (Freeze === 1) {
        return handleFreeze();
      }
      setLoading(true);
      let payLoad = JSON.parse(JSON.stringify(data));
      payLoad.expiredtimestamp = 0;
      console.log({ payLoad });
      delete payLoad.errorFields;
      delete payLoad.errorStatus;
      delete payLoad.__typename;
      delete payLoad.enteredtimestamp;
      delete payLoad.lastupdatedby;
      // delete payLoad.expiredtimestamp;
      // payLoad.companyid = companyDetailsData.companyid;
      delete payLoad.companyid;
      // let response = await API.graphql(
      //   graphqlOperation(createPaymentSettings, {
      //     paymentSettingsInput: [payLoad],
      //   })
      // );
      let response = await createPaymentSettings({
        paymentSettingsInput: [payLoad],
      });
      showSuccessSnackbar('Payment Settings Updated !');
      setBool(false);
      if (parent !== 'advancedsettings') {
        // navigate("/");
      }
      // dispatch(fetchPaymentSettings());
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const { data: paymentSettingsList, isSuccess: isPaymentListingSuccess } = useGetPaymentSettingsQuery();
  const fetchData = async () => {
    try {
      setLoading(true);
      let response = { data: { getPaymentSettings: paymentSettingsList } };
      // let response = await API.graphql(graphqlOperation(getPaymentSettings));
      console.log(response, 'data');
      if (response.data.getPaymentSettings[0]?.companyid != null) {
        setdata((prev) => ({
          ...prev,
          ...response.data.getPaymentSettings[0],
        }));
      } else {
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  let checkBox = [
    // {
    //   name: "Enable_ItemWiseEntry",
    //   label: "Enable bill-wise receipt/payments",
    // },
    {
      name: 'enable_creditperiod',
      label: 'Enable Credit Period',
    },
    {
      name: 'enable_creditlimit',
      label: 'Enable Credit Limit',
    },
    {
      name: 'enable_autopayreminder',
      label: 'Enable Automatic Payment Reminders',
    },
  ];

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.checked;
    if (name === 'enable_autopayreminder' && !value) {
      setdata((prev) => ({
        ...prev,
        [name]: value ? 1 : 0,
        enable_autoreminderdays: 0,
      }));
    } else {
      setdata((prev) => ({ ...prev, [name]: value ? 1 : 0 }));
    }
  };
  useEffect(() => {
    if (isPaymentListingSuccess) fetchData();
    console.log(isPaymentListingSuccess, paymentSettingsList, 'data');
  }, [isPaymentListingSuccess]);
  console.log(data.enable_autoreminderdays);
  useSaveShortcut(() => {
    if (!emailExpand) {
      saveChanges();
    }
  });

  const [EmailModal, setEmailModal] = useState(false);
  const handleEmailModalOpen = () => setEmailModal(true);
  const handleEmailModalClose = () => setEmailModal(false);
  const handleChangedays = (e) => {
    let value = parseInt(e.target.value, 10) ?? 0;

    if (value < 0) {
      setdata((prev) => ({
        ...prev,
        errorFields: {
          ...prev.errorFields,
          enable_autoreminderdays: 'Invalid Value',
        },
        errorStatus: {
          ...prev.errorStatus,
          enable_autoreminderdays: true,
        },
      }));
    } else if (value == ' ') {
      setdata((prev) => ({
        ...prev,
        enable_autoreminderdays: 0,
        errorFields: {
          ...prev.errorFields,
          enable_autoreminderdays: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          enable_autoreminderdays: false,
        },
      }));
    } else {
      setdata((prev) => ({
        ...prev,
        enable_autoreminderdays: value,
        errorFields: {
          ...prev.errorFields,
          enable_autoreminderdays: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          enable_autoreminderdays: false,
        },
      }));
    }
  };
  console.log(data, 'datamm');
  return (
    <Box
      sx={{
        boxSizing: 'content-box',
      }}
    >
      <Box
        sx={{
          minHeight: height ? `${height}px` : '550px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Paper
          sx={{
            padding: { xs: '8px', sm: '20px' },
            borderRadius: '8px',
            boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '24px',
            }}
          >
            {title}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column' }} className={bool == false ? 'disable-interactions' : ''}>
            {checkBox.map((element) => {
              console.log(data, 'datahh');
              console.log(element, 'element');
              console.log(checkBox, 'checkBox');
              return (
                <FormControlLabel
                  control={<Checkbox name={element.name} checked={data[element.name] >= 1} onChange={handleChange} />}
                  label={element.label}
                />
              );
            })}
            {data?.['enable_autopayreminder'] > 0 && (
              <Typography
                component={'div'}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '40px',
                }}
              >
                Enable Automatic Reminder in &nbsp;{' '}
                <div style={{ display: 'inline', width: '80px' }}>
                  <InputField
                    state={data}
                    name={'enable_autoreminderdays'}
                    value={data.enable_autoreminderdays}
                    onChange={handleChangedays}
                    type="number"
                    sx={{
                      width: '60px',
                      display: 'inline-block',
                      '.MuiInputBase-input': { padding: '5px' },
                    }}
                  />{' '}
                </div>
                &nbsp; Days
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              margin: '15px',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              gap: '10px',
            }}
          >
            <Button
              variant="outlined"
              sx={{
                width: { sm: '300px', md: '350px' },
                height: '40px',
                display: 'flex',
                justifyContent: 'space-around',
              }}
              disabled={bool === false}
            >
              <StickyNote2 />{' '}
              <span
                onClick={() => {
                  return handleEmailModalOpen();
                }}
                style={{ textDecoration: 'none', fontSize: '12px' }}
              >
                View Reminder Payment Template
              </span>
            </Button>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              {bool ? (
                <Tooltip
                  arrow
                  title={
                    !emailExpand ? (
                      <Box display="flex" alignItems="center">
                        <Typography variant="body2" sx={{ fontSize: '11px' }}>
                          Press <kbd>ctrl</kbd> + <kbd>s</kbd>
                        </Typography>
                      </Box>
                    ) : (
                      ''
                    )
                  }
                >
                  <Button onClick={saveChanges} variant="contained">
                    Save
                  </Button>
                </Tooltip>
              ) : (
                <Button variant="contained" onClick={() => setBool(true)} color="primary" sx={{ fontSize: '14px' }}>
                  Enable Edit
                </Button>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>
      <Modal open={EmailModal} onClose={handleEmailModalClose}>
        <Modal.Header>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 10px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Email Settings
                <IconButton aria-label="delete" onClick={handleEmailModalClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <EmailSettings onSaveComplete={handleEmailModalClose} select={2} parent="payment" />
        </Modal.Body>
      </Modal>
    </Box>
  );
};

export default PaymentSettings;
